import type { EstadoSuscripcion, ModoSuscripcion } from '../api/operaciones';

/**
 * «Solo lectura» del panel (0.4, 0.5; G13, G55, G70, G114). Ya no es una línea: es el chip «Solo lectura» junto a la
 * campana y una **franja** roja con su motivo (`logica/franjas.ts`). El modo sale de `listEntitlements` (o, si la persona
 * no puede verlo, del `mode` de `getMyNavigation`); el motivo, del estado de la suscripción o del acceso de Soporte.
 * Motivos y acciones: los del diseño (0.1, franja «Solo lectura por …»).
 */
export interface MotivoSoloLectura {
    /** «pausa de temporada», «prueba caducada»…, para «Solo lectura por …»; vacío si no se sabe. */
    motivo: string;
    /** Lo que puede hacer el Propietario («Reactivar», «Contratar»…); null si no hay acción. */
    accion: string | null;
}

const MOTIVOS: Partial<Record<EstadoSuscripcion, MotivoSoloLectura>> = {
    trial_expired: { motivo: 'prueba caducada', accion: 'Contratar' },
    suspended: { motivo: 'impago', accion: 'Pagar la cuota' },
    paused: { motivo: 'pausa de temporada', accion: 'Reactivar' },
    cancelled: { motivo: 'baja del negocio', accion: 'Volver a contratar' },
};

/** Soporte de Reservaria dentro del negocio sin permiso de escritura (G70): solo lectura, sin acción. */
const ACCESO_DE_SOPORTE: MotivoSoloLectura = { motivo: 'acceso de soporte', accion: null };

export function enSoloLectura(modo: ModoSuscripcion): boolean {
    return modo === 'read_only';
}

/**
 * Motivo de la franja de solo lectura, o null si el negocio opera con normalidad. Manda el del estado de la suscripción;
 * si no lo explica y hay un acceso de Soporte en lectura, es por el acceso. Si no se sabe, motivo vacío (no se inventa).
 */
export function motivoSoloLectura(modo: ModoSuscripcion, estado: EstadoSuscripcion | null, accesoDeSoporte = false): MotivoSoloLectura | null {
    if (!enSoloLectura(modo)) {
        return null;
    }
    const delEstado = estado === null ? undefined : MOTIVOS[estado];
    if (delEstado !== undefined) {
        return delEstado;
    }
    return accesoDeSoporte ? ACCESO_DE_SOPORTE : { motivo: '', accion: null };
}
